import React, { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';

interface LogoProps {
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({ className }) => {
  const [isMobile, setIsMobile] = useState(false);
  
  // Detect if device is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768); // md breakpoint
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  
  // Pick the artwork by size. Theme is picked by CSS (the root .dark class),
  // so the logo can never disagree with the page colours around it.
  const [light, dark] = isMobile
    ? ['/images/HQ Transparent-03.png', '/images/HQ Transparent-04.png'] // icon + text, stacked
    : ['/images/HQ Transparent-01.png', '/images/HQ Transparent-02.png']; // icon + text, wide
  const size = cn(
    isMobile ? 'h-12 max-w-[48px]' : 'h-11 max-w-[224px]',
    'w-auto'
  );

  return (
    <div className={cn('transition-transform group-hover:scale-105', className)}>
      <img src={light} alt="Light Hunt" className={cn(size, 'dark:hidden')} />
      <img src={dark} alt="" aria-hidden="true" className={cn(size, 'hidden dark:block')} />
    </div>
  );
};